// extracted by mini-css-extract-plugin
export var actions = "_3p-0";
export var actionsContainer = "_3p-6";
export var border = "_3p-1";
export var childFullHeight = "_3p-d";
export var collapse = "_3p-2";
export var content = "_3p-8";
export var contentChild = "_3p-c";
export var fullscreen = "_3p-a";
export var headerContainer = "_3p-3";
export var headerRow = "_3p-5";
export var hidePadding = "_3p-9";
export var noScrollX = "_3p-e";
export var noScrollY = "_3p-f";
export var optOutTopPadding = "_3p-b";
export var pagePadding = "_3p-7";
export var profile = "_3p-g";
export var profileContainer = "_3p-h";
export var profileImage = "_3p-i";
export var profileMain = "_3p-j";
export var profileSubtitle = "_3p-l";
export var profileTitle = "_3p-k";
export var tabsWrapper = "_3p-4";
export var title = "_3p-m";